import {IMyAccountUploadDocumentsExternalLinkHandler} from "./my-account-upload-documents.external-link-handler.interface";
import {
    ExternalLinkInIframeHandlerBase,
    ExternalLinkInIframeRendererParams
} from "../external-link-in-iframe-handler-base";
import {GNWP_SOURCES} from "../../../gnwp/gnwp-consts";
import {ExternalLinksZIndexes} from "../../external-links-z-indexes";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";
import {CyClass} from "../../../../../common/cy-classes";


export class MyAccountUploadDocumentsExternalLinkHandler extends ExternalLinkInIframeHandlerBase implements IMyAccountUploadDocumentsExternalLinkHandler {

    async openUploadDocumentsFromMyAccount(): Promise<void> {
        if(!await this.services.user.ensureUserIsLoggedIn('Upload documents')) {
            return;
        }

        const url = await this._getGnwpUrl();
        await this._showExternalLinkDialog(url);
    }

    protected async _getGnwpUrl(): Promise<string> {
        return this.services.gnwp.getUploadDocumentsUrl();
    }

    protected _getGnwpSource(): GNWP_SOURCES {
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            maxWidth: 940,
            maxHeight: 658,
            zIndex: ExternalLinksZIndexes.MyAccount,
            hideCloseButton: this._hideCloseButton,
            httpVerb: 'POST',
            analyticsAction: this._getGnwpSource(),
            iframeExtraCssClass: CyClass('cy-upload-documents-external-link-container')
        };
    }

    protected get _hideCloseButton(): boolean {
        return false;
    }

    protected async _onPostMessageReceived(message: MessageEvent): Promise<void> {
        const actionId = this._extractActionId(message);
        if(!actionId) {
            return;
        }

        switch (actionId) {
            case 'CloseMe':
                this._closeExternalLinkDialog();
                break;
            case '6':
                await this._openCashier({
                    tabId: this._extractCashierTabId(message),
                    promCode: this._extractPromoCode(message),
                    channel: {
                        source: CHANNEL_SOURCE.uploadDocuments,
                        area: AreaType.Header
                    }
                });
                break;
            case '7':
                await this._openQuickDeposit({
                    promCode: this._extractPromoCode(message),
                    channel: {
                        source: CHANNEL_SOURCE.uploadDocuments,
                        area: AreaType.Header,
                        element: CHANNEL_ELEMENTS.depositButton
                    }
                });
                break;
        }
    }



}